// Company details. Single source of truth for contact data.
const site = {
  name: 'ISL Technologies',
  shortName: 'ISL Tech',
  domain: 'https://isl-technologies.com',
  email: 'contact@isl-technologies.com',
  phone: '+381 62 8597086',
  phoneHref: 'tel:+381628597086',
  // The client asked not to mention the city name on the page.
  office: 'Janka Veselinovića 44, Serbia',
  linkedin: 'https://www.linkedin.com/company/isl-tech',
  tagline: 'Custom software and production AI for growing companies, worldwide.',
  year: 2026,
};
export default site;

export const NAV = [
  { label: 'Services', href: '#services' },
  { label: 'Work', href: '#work' },
  { label: 'Industries', href: '#industries' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

// Confirm real numbers with ISL before launch.
export const STATS = [
  { value: '10+', label: 'Years in business' },
  { value: '120+', label: 'Projects delivered' },
  { value: 'EU · UK · US', label: 'Client regions', nowrap: true },
];
